import GeneralContent from './GeneralContent';

export default {
  list: GeneralContent,
};